import { render } from "./SplititContainer.vue?vue&type=template&id=ad5b3a1c&scoped=true"
import script from "./SplititContainer.vue?vue&type=script&lang=js"
export * from "./SplititContainer.vue?vue&type=script&lang=js"

import "./SplititContainer.vue?vue&type=style&index=0&id=ad5b3a1c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ad5b3a1c"]])

export default __exports__